import Vue from "vue";

import SearchBox from "@Region/Scripts/Components/Search/SearchBox.vue";
import SupportRequest from "@Region/Scripts/Components/SupportRequest/SupportRequest.vue";

import CookieToast from "@Scripts/Components/CookieToast/CookieToast.vue";
import LanguageSelector from "@Scripts/Components/LanguageSelector/LanguageSelector.vue";
import LanguageSelectorButton from "@Scripts/Components/LanguageSelector/LanguageSelectorButton.vue";
import Pagination from "@Scripts/Components/Pagination/Pagination.vue";
import Locator from "@Scripts/Components/Locator/Locator.vue";
import SkeletonLoader from "@Scripts/Components/SkeletonLoader/SkeletonLoader.vue";

export default class AppConfig {
    public static AddComponents() {
        Vue.component("reg-searchbox", SearchBox);
        Vue.component("reg-supportrequest", SupportRequest);

        Vue.component("app-cookietoast", CookieToast);
        Vue.component("app-languageselector", LanguageSelector);
        Vue.component("app-languageselectorbutton", LanguageSelectorButton);
        Vue.component("app-pagination", Pagination);
        Vue.component("app-locator", Locator);
        Vue.component("app-skeletonloader", SkeletonLoader);
    }
}